import { APP_STARTED } from './ActionTypes';
export const startApp = () => ({
  type: APP_STARTED
});